/**
 * Deep equality comparison of objects
 * @param {*} obj1 First object to compare
 * @param {*} obj2 Second object to compare
 * @returns {boolean} Whether the objects are deeply equal
 */
export const deepEqual = (obj1, obj2) => {
  // Check if both are exactly the same
  if (obj1 === obj2) return true

  // Check if either is null or not an object
  if (obj1 === null || obj2 === null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return false
  }

  // Check array equality separately
  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length !== obj2.length) return false
    return obj1.every((val, i) => deepEqual(val, obj2[i]))
  }

  // Check if one is array and the other is not
  if (Array.isArray(obj1) !== Array.isArray(obj2)) return false

  // Compare object keys
  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)

  if (keys1.length !== keys2.length) return false

  return keys1.every((key) => Object.hasOwn(obj2, key) && deepEqual(obj1[key], obj2[key]))
}
